import { autoCapitalize } from '@/utils/autoCapitalize'
import { ResponsibleListData } from './ResponsibleListMapper.types'

class ResponsibleListMapper {
  toDomain(persistenceClinicData: ResponsibleListData) {
    return {
      id: persistenceClinicData?.idUsuario,
      name: autoCapitalize(persistenceClinicData?.nome),
    }
  }
}

export default new ResponsibleListMapper()
